<template>
  <div class="partner">
    <div v-if="!formSend">
      <div class="partner__title">Регистрация партнера</div>
      <div class="partner__caption">Статус партнера дает доступ к расширенному функционалу и доступ к проф. настройкам
      </div>
      <form @submit.prevent="submitForm">
        <div v-for="(item, index) in inputList" :key="index" class="partner__group">
          <div class="partner__label">
            <label
              :for="`new-partner-${item.id}`">
              <span>*</span>
              {{ item.text }}
            </label>
          </div>
          <div v-if="item.id === 'phone'" class="partner__phone">
            <Phone ref="phone" class="partner__phone-content" />
          </div>
          <div v-else class="partner__input">
            <input
              :class="[{'border': formData[item.id].length === 0}, {'mail': item.id === 'email'}]"
              v-model.trim="formData[item.id]"
              :id="`new-partner-${item.id}`"
              type="text"
            />
          </div>
        </div>
        <div class="partner__group" v-if="getDealerName">
          <div class="partner__label">Вышестоящая компания:</div>
          <div class="partner__input partner__input--text">{{ getDealerName }}</div>
        </div>
        <div class="partner__group">
          <div class="partner__label">
            <label>Наличие производства:</label>
          </div>
          <div class="partner__input">
            <v-select
              v-model="formData.has_production"
              label="label"
              :options="productionList"
              lsbel="label"
              class="partner__select"
            />
          </div>
        </div>
        <div class="partner__group" v-if="partnerActivity">
          <div class="partner__label">Основной вид деятельности:</div>
          <ul class="partner__list">
            <li v-for="(item, index) in partnerActivity" :key="index" class="partner__checkbox">
              <input
                :value="item.value"
                @input="updatePartnerActivityValue({
                  'index': index,
                  'val': $event.target.checked,
                })"
                :id="`new-partner-activity-${index}`"
                type="checkbox"
              />
              <label :for="`new-partner-activity-${index}`">{{ item.name }}</label>
            </li>
          </ul>
        </div>
        <div class="partner__panel">
          <BaseBtn
            :text="'Зарегистрироваться'"
            :disabled="!getDealerName"
            @btnClick="submitForm" />

          <div class="partner__login">
            <div class="oparetner__Login-caption">Уже зарегистрированы?</div>
            <a :href="`${windowLocation()}/login`">Войти в личный кабинет</a>
            <span>|</span>
            <a :href="`${windowLocation()}/password/reset`">Восстановить пароль</a>
          </div>
        </div>
      </form>
      <notifications/>
    </div>
    <div v-else>
      <div class="partner__title">Спасибо, ваша анкета принята на проверку,</div>
      <div class="partner__caption">на указанный адрес электронной почты вам придет сообщение с указанием пароля для
        входа в личный кабинет
      </div>
      <router-link to="/" class="partner__button">ОК</router-link>
    </div>

    <DangerPopup />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'PartnerNew',

  components: {
    BaseBtn: () => import('@/components/base/BaseBtn'),
    Phone: () => import('@/components/Phone'),
    DangerPopup: () => import('@/elements/Popup/DangerPopup')
  },

  props: {
    uuid: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dealerName: '',
      formSend: false,
      formData: {
        has_production: {
          id: 0,
          label: 'Нет',
        },
        agent: '',
        email: '',
        name: '',
        dealer_organization: '',
        town: '',
      },
      productionList: [
        {
          id: 1,
          label: 'Есть',
        },
        {
          id: 0,
          label: 'Нет',
        }
      ],
      inputList: [
        {
          text: 'ФИО:',
          id: 'agent',
        },
        {
          text: 'Телефон:',
          id: 'phone',
        },
        {
          text: 'E-mail:',
          id: 'email',
        },
        {
          text: 'Наименование компании:',
          id: 'name',
        },
        // {
        //   text: 'Юр. лицо:',
        //   id: 'dealer_organization',
        // },
        {
          text: 'Город:',
          id: 'town',
        },
      ]
    }
  },

  validations: {
    formData: {
      agent: {
        required,
      },
      email: {
        required,
        email,
      },
      name: {
        required,
      },
      town: {
        required,
      },
    }
  },

  computed: {
    ...mapState({
      partnerActivity: state => state.partners.partnerActivity,
      partner: state => state.partners.partner,
    }),

    getDealerName() {
      return this.dealerName
    },
  },

  methods: {
    ...mapActions('partners', [
      'loadPartnerActivity',
      'loadPartner',
      'loadDealerName',
      'addNewPartner',
    ]),

    ...mapMutations('partners', [
      'updatePartnerActivityValue',
    ]),

    checkError() {
      if (this.$v.formData.agent.$error) {
        return 'Вы не указали Вашу фамилию и инициалы';
      } else if (this.hasPhoneError()) {
        return 'Вы не указали Ваш телефон';
      } else if (this.$v.formData.email.$error) {
        return 'Вы не указали адрес Вашей эл. почты';
      } else if (this.$v.formData.name.$error) {
        return 'Вы не указали Вашe наименование компании';
      } else if (this.$v.formData.town.$error) {
        return 'Вы не указали Ваш город';
      }
    },

    hasPhoneError() {
      return this.$refs.phone[0].hasError();
    },

    submitForm() {
      this.$v.$touch()
      if (this.$v.$invalid || this.hasPhoneError()) {
        this.updateDangerPopup({
          isOpen: true,
          text: this.checkError(),
        });
      } else {
        const phone = this.$refs.phone[0];

        this.addNewPartner({
          'id': this.uuid,
          'body': {
            'agent': this.formData.agent,
            'email': this.formData.email,
            'name': this.formData.name,
            'dealer_organization': this.formData.dealer_organization,
            'phone': `${phone.country.code} ${phone.phone}`,
            'town': this.formData.town,
            'activities': this.partnerActivity,
            'has_production': this.formData.has_production.id,
          }
        }).then(res => {
          this.formSend = true;
        }).catch(error => {
          this.updateDangerPopup({
            isOpen: true,
            text: error,
          });
        })
      }
    },

    windowLocation() {
      return window.location.origin
    },
  },

  created() {
    this.loadDealerName(this.uuid)
      .then(dealerName => {
        this.dealerName = dealerName;
      })
      .catch(error => {
        this.updateDangerPopup({
          isOpen: true,
          text: 'Ошибка при получении информации о вышестоящем дилере',
        });
      });

    this.loadPartnerActivity();
  },

};
</script>

<style scoped lang="scss">
.partner {
  padding: 30px 15px;

  &__login {
    font-size: 12px;
    margin-top: 20px;
    text-align: center;

    &-caption {
      margin-bottom: 10px;
    }

    span {
      padding: 0 5px;
    }

    a {
      color: #39aee3;
    }
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 9px;
    text-align: center;

    @media(max-width: $desktop) {
      margin-bottom: 20px;
    }
  }

  &__caption {
    font-size: 14px;
    line-height: 18px;
    color: #B2B2B2;
    margin-bottom: 26px;
    text-align: center;
  }

  &__group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 63px;
    }

    @media(max-width: $desktop) {
      margin-bottom: 12px;
      display: block;
    }
  }

  &__select {
    width: 60px;

    @media(max-width: $desktop) {
      width: 100%;
    }

    ::v-deep .vs__selected {
      font-size: 14px;
      padding: 0;
    }

    ::v-deep .vs__search,
    ::v-deep .vs__search:focus {
      padding: 0;
    }

    ::v-deep .vs__actions {
      bottom: 0;
    }
  }

  &__phone,
  &__input {
    width: 50%;

    @media(max-width: $desktop) {
      width: 100%;
    }
  }

  &__phone-content {
    width: 240px;

    @media(max-width: $desktop) {
      width: 100%;
    }
  }

  &__input {
    input {
      font-weight: bold;
      font-size: 14px;
      line-height: 15px;
      border: none;
      border-bottom: 1px solid transparent;
      padding: 0;
      height: 15px;
      width: 240px;
      transition: 0.3s;

      @media(max-width: $desktop) {
        width: 100%;
      }

      &.border,
      &:focus {
        border-color: rgba(53, 52, 55, 0.15);
      }

      &.mail {
        color: #4B9DBD;
        text-decoration: underline;

        &.border,
        &:focus {
          text-decoration: none;
        }
      }
    }

    &--text {
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &__label {
    font-size: 14px;
    line-height: 20px;
    color: #5E5E5E;
    margin-right: 15px;
    width: 50%;
    text-align: right;

    @media(max-width: $desktop) {
      width: 100%;
      text-align: left;
      margin-bottom: 2px;
      line-height: 18px;
      color: #979797;
    }

    label {
      cursor: pointer;
      display: inline-block;

      span {
        color: #ff3c3c;
      }
    }
  }

  &__list {
    width: 50%;

    @media(max-width: $desktop) {
      width: 100%;
      padding-top: 10px;
    }

    li {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__checkbox {
    input {
      display: none;
    }

    label {
      padding-left: 25px;
      display: inline-block;
      font-size: 14px;
      line-height: 20px;
      position: relative;

      &:before,
      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        margin: auto;
        transition: 0.3s;
        top: -2px;
      }

      &:before {
        width: 14px;
        height: 14px;
        border-radius: 100%;
        border: 1px solid #353437;
        left: 0;
      }

      &:after {
        width: 16px;
        height: 16px;
        left: -1px;
        opacity: 0;
        background-image: url("/img/check.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 9px auto;
      }
    }

    input:checked + label {
      &:before {
        background-color: #353437;
      }

      &:after {
        opacity: 1;
      }
    }
  }

  &__button {
    width: 166px;
    height: 32px;
    margin: 0 auto;
    display: block;
    background: #353437;
    border: 1px solid #353437;
    padding: 0;
    font-size: 16px;
    color: #fff;
    transition: 0.3s;
    text-align: center;
    text-decoration: none;
    line-height: 30px;

    @media(min-width: $desktop) {
      &:hover {
        background-color: #fff;
        color: #353437;
      }
    }
  }

  &__panel {
    padding-top: 26px;
  }
}
</style>
